import { cx } from '../classname.js';

// will move this to common place if there are other components that need it
// will add more scales if needed
var INTERACTIVE_SCALE_CLASS_MAP = {
  0.96: 'interactive-scale-96'
};

// Function to get the interactive scale class based on the scale value and return it as a string
var addInteractiveScaleClass = function addInteractiveScaleClass(className, scale) {
  return "".concat(className, " ").concat(cx([INTERACTIVE_SCALE_CLASS_MAP[scale]]));
};

export { addInteractiveScaleClass };
//# sourceMappingURL=addInteractiveScaleClass.js.map
